<template>
  <div>
    <p v-text="filtros.descricao" class="ma-0 font-weight-medium font-13 text-gray-900" />

    <div>
      <v-btn icon class="ml-n2" @click="selecionarTudo">
        <v-icon v-if="filtros_selecionados.length === 0">mdi-checkbox-blank-outline</v-icon>
        <v-icon v-else-if="filtros_selecionados.length === filtrosSelecionaveis.length" color="primary">mdi-checkbox-marked</v-icon>
        <v-icon v-else color="primary">mdi-minus-box</v-icon>
      </v-btn>

      <span class="font-weight-medium">
        {{ (filtros_selecionados.length !== filtrosSelecionaveis.length) ? 'Marcar tudo' : 'Desmarcar tudo' }}
      </span>
    </div>

    <div v-for="filtro in filtros.dados" :key="filtro.id">
      <!-- <template v-if="filtro.chave === 'analise_lote'">
        <FiltrosAutocomplete
          v-model="ANALISE_LOTE_STORE"
          :items="selects.aplicacao"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          class="mt-2 pr-3"
          label="Analise Por Lote"
        />
      </template> -->

      <template v-if="filtro.chave === 'histogramas'">
        <FiltrosAutocomplete
          v-model="HISTOGRAMAS_STORE"
          :items="selects.histogramas"
          label="Histogramas"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          class="mt-2 pr-3"
        />

        <FiltrosAutocomplete
          v-if="exibirFiltroProdutosForaDeLinha"
          v-model="STATUS_STORE"
          :items="selects.status_ativo_fora_linha_produtos"
          label="Status"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          class="mt-2 pr-3"
        />
      </template>

      <template v-else-if="filtro.chave === 'venda_futura'">
        <v-btn icon class="ml-n2" @click="aplicarVendaFutura()">
          <v-icon v-if="!APLICACAO_STORE.includes('PRODUTO_EM_VENDA_FUTURA')">mdi-checkbox-blank-outline</v-icon>
          <v-icon v-else color="primary">mdi-checkbox-marked</v-icon>
        </v-btn>

        <v-tooltip top open-delay="700">
          <template v-slot:activator="{on, attrs}">
            <span v-bind="attrs" v-on="on" class="cursor-help">{{ filtro.title }}</span>
          </template>
          <span>{{ filtro.tooltip }}</span>
        </v-tooltip>
      </template>

      <template v-else-if="filtro.chave === 'analise_lote'">
        <v-btn icon class="ml-n2" @click="aplicarAnalisePorLote()">
          <v-icon v-if="!APLICACAO_STORE.includes('PRODUTO_EM_ANALISE_POR_LOTES')">mdi-checkbox-blank-outline</v-icon>
          <v-icon v-else color="primary">mdi-checkbox-marked</v-icon>
        </v-btn>

        <v-tooltip top open-delay="700">
          <template v-slot:activator="{on, attrs}">
            <span v-bind="attrs" v-on="on" class="cursor-help">{{ filtro.title }}</span>
          </template>
          <span>{{ filtro.tooltip }}</span>
        </v-tooltip>
      </template>

      <template v-else>
        <v-btn icon class="ml-n2" @click="selecionarFiltro(filtro)">
          <v-icon v-if="!filtros_selecionados.includes(filtro)">mdi-checkbox-blank-outline</v-icon>
          <v-icon v-else color="primary">mdi-checkbox-marked</v-icon>
        </v-btn>

        <v-tooltip top open-delay="700">
          <template v-slot:activator="{on, attrs}">
            <span v-bind="attrs" v-on="on" class="cursor-help">{{ filtro.title }}</span>
          </template>
          <span>{{ filtro.tooltip }}</span>
        </v-tooltip>
      </template>
    </div>
  </div>
</template>

<script>
import FiltrosAutocomplete from "@/components/compra/ProdutosGerais/Filtros/FiltrosAutocomplete.vue";

export default {
  name: "FiltrosTipo",
  components: {FiltrosAutocomplete },
  props: {
    filtros: Object,
  },
  data: () => ({
    filtros_selecionados: [],
    histogramas: [],
    selects: {
      histogramas: [
        { valor: '0. Sem histórico de vendas', descricao: '0. Sem histórico de vendas' },
        { valor: '1. Até 1 mês sem vender', descricao: '1. Até 1 mês sem vender' },
        { valor: '2. De 1 a 2 meses sem vender', descricao: '2. De 1 a 2 meses sem vender' },
        { valor: '3. De 2 a 3 meses sem vender', descricao: '3. De 2 a 3 meses sem vender' },
        { valor: '4. De 3 a 6 meses sem vender', descricao: '4. De 3 a 6 meses sem vender' },
        { valor: '5. De 6 a 9 meses sem vender', descricao: '5. De 6 a 9 meses sem vender' },
        { valor: '6. De 9 a 12 meses sem vender', descricao: '6. De 9 a 12 meses sem vender' },
        { valor: '7. Acima de 12 meses sem vender', descricao: '7. Acima de 12 meses sem vender' },
      ],
      aplicacao: [
        { valor: 'PRODUTO_EM_ANALISE_POR_LOTES', descricao: '0. Produto em Análise por Lotes' },
        { valor: 'PRODUTO_EM_VENDA_FUTURA', descricao: '1. Produtos com Venda Futura' },
      ],
      status_ativo_fora_linha_produtos: [
        { valor: 'A', descricao: '1. Ativo' },
        { valor: 'FL', descricao: '2. Fora de Linha' }
      ],
    },
    outros_filtros: {
      status_ativo_fora_linha_produtos: []
    },
  }),
  computed: {
    HISTOGRAMAS_STORE: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getHistogramas'];
      },
      set: function (valor) {
        this.$store.dispatch('CompraProdutosGerais/setHistogramas', valor);
      }
    },
    STATUS_STORE: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getStatus'];
      },
      set: function (valor) {
        this.$store.dispatch('CompraProdutosGerais/setStatus', valor);
      }
    },
    APLICACAO_STORE: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getAplicacao'];
      },
      set: function (valor) {
        this.$store.dispatch('CompraProdutosGerais/setAplicacao', valor);
      }
    },
    filtrosSelecionaveis() {
      return this.filtros.dados.filter(f => f.chave !== 'histogramas');
    },
    exibirFiltroProdutosForaDeLinha() {
      return localStorage.compras_exibir_filtro_fora_linha_tela_compras_fornecedor === 'S';
    }
  },
  watch: {
    filtros_selecionados(valores) {
      this.$emit('filtros_selecionados', { tipo: this.filtros.id, filtros: valores });
    }
  },
  mounted() {
    this.filtros_selecionados = [];
    this.sincronizarFiltrosAplicacao();
  },
  methods: {
    sincronizarFiltrosAplicacao() {
      const filtro_venda_futura = this.filtros.dados.find(f => f.chave === 'venda_futura');
      const filtro_analise_lote = this.filtros.dados.find(f => f.chave === 'analise_lote');

      if (this.APLICACAO_STORE.includes('PRODUTO_EM_VENDA_FUTURA') && filtro_venda_futura) {
        if (!this.filtros_selecionados.includes(filtro_venda_futura)) {
          this.filtros_selecionados.push(filtro_venda_futura);
        }
      }

      if (this.APLICACAO_STORE.includes('PRODUTO_EM_ANALISE_POR_LOTES') && filtro_analise_lote) {
        if (!this.filtros_selecionados.includes(filtro_analise_lote)) {
          this.filtros_selecionados.push(filtro_analise_lote);
        }
      }
    },
    aplicarVendaFutura() {
      const filtro = this.filtros.dados.find(f => f.chave === 'venda_futura');

      if (this.APLICACAO_STORE.includes('PRODUTO_EM_VENDA_FUTURA')) {
        this.APLICACAO_STORE = this.APLICACAO_STORE.filter(item => item !== 'PRODUTO_EM_VENDA_FUTURA');
        this.filtros_selecionados = this.filtros_selecionados.filter(item => item !== filtro);
      } else {
        this.APLICACAO_STORE.push('PRODUTO_EM_VENDA_FUTURA');
        if (filtro && !this.filtros_selecionados.includes(filtro)) {
          this.filtros_selecionados.push(filtro);
        }
      }
    },
    aplicarAnalisePorLote() {
      const filtro = this.filtros.dados.find(f => f.chave === 'analise_lote');

      if (this.APLICACAO_STORE.includes('PRODUTO_EM_ANALISE_POR_LOTES')) {
        this.APLICACAO_STORE = this.APLICACAO_STORE.filter(item => item !== 'PRODUTO_EM_ANALISE_POR_LOTES');
        this.filtros_selecionados = this.filtros_selecionados.filter(item => item !== filtro);
      } else {
        this.APLICACAO_STORE.push('PRODUTO_EM_ANALISE_POR_LOTES');
        if (filtro && !this.filtros_selecionados.includes(filtro)) {
          this.filtros_selecionados.push(filtro);
        }
      }
    },
    selecionarFiltro(filtro) {
      if (!this.filtros_selecionados.includes(filtro)) {
        this.filtros_selecionados.push(filtro);
        return;
      }

      this.filtros_selecionados = this.filtros_selecionados.filter(item => item !== filtro);
    },
    selecionarTudo() {
      const filtros_selecionaveis = this.filtrosSelecionaveis;
      const todos_selecionados = this.filtros_selecionados.length === filtros_selecionaveis.length;

      const tem_venda_futura = filtros_selecionaveis.some(f => f.chave === 'venda_futura');
      const tem_analise_lote = filtros_selecionaveis.some(f => f.chave === 'analise_lote');

      if (todos_selecionados) {
        this.filtros_selecionados = [];

        if (tem_venda_futura || tem_analise_lote) {
          this.APLICACAO_STORE = this.APLICACAO_STORE.filter(item =>
            item !== 'PRODUTO_EM_VENDA_FUTURA' &&
            item !== 'PRODUTO_EM_ANALISE_POR_LOTES'
          );
        }
        return;
      }

      this.filtros_selecionados = [...filtros_selecionaveis];

      if (tem_venda_futura || tem_analise_lote) {
        const aplicacao = new Set(this.APLICACAO_STORE);

        if (tem_venda_futura) {
          aplicacao.add('PRODUTO_EM_VENDA_FUTURA');
        }

        if (tem_analise_lote) {
          aplicacao.add('PRODUTO_EM_ANALISE_POR_LOTES');
        }

        this.APLICACAO_STORE = [...aplicacao];
      }
    }
  }
}
</script>
